import { FC, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Textarea } from 'core-components/library/inputs'
import { IPartnerContact } from 'partner360/features/contacts'

import styles from './ContactShortBio.module.scss'

interface IContactShortBioProps {
  contact: IPartnerContact
  isContactEditing: boolean
  onChange: (contact: IPartnerContact) => void
}

export const ContactShortBio: FC<IContactShortBioProps> = ({
  contact,
  isContactEditing,
  onChange,
}) => {
  const handleChangeShortBio = useCallback(
    (value: string) => {
      const updatedContact = {
        ...contact,
        ShortBio: value,
      }
      onChange(updatedContact)
    },
    [contact, onChange]
  )

  if (!isContactEditing) {
    return (
      <div className={styles.editRoot}>
        <Textarea
          disabled
          label={<Translation text="jbp-partnercontactinfo--short-bio-label" />}
          classes={{
            root: styles.textarea,
          }}
          value={contact.ShortBio || '-'}
          onChange={handleChangeShortBio}
        />
      </div>
    )
  }

  return (
    <div className={styles.editRoot}>
      <Textarea
        label={<Translation text="jbp-partnercontactinfo--short-bio-label" />}
        classes={{
          root: styles.textarea,
        }}
        value={contact.ShortBio}
        onChange={handleChangeShortBio}
      />
    </div>
  )
}
